import script from "./PageSmartBrainHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSmartBrainHome.vue?vue&type=script&setup=true&lang=js"

import "./PageSmartBrainHome.vue?vue&type=style&index=0&id=793be9f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793be9f2"]])

export default __exports__